import { render, staticRenderFns } from "./WaterNutrients.vue?vue&type=template&id=7f5a5c1c"
import script from "./WaterNutrients.vue?vue&type=script&lang=js"
export * from "./WaterNutrients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports